import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import api from '../../services/api';
import directions from '../../utils/directionsData';
import Analytics from '../../services/Analytics';

import AnimationContainer from '../../common/FadeAnimation';
import StartScreenMain from '../../components/StartScreenMain';
import DirectionSection from '../../components/DirectionSection';
import Clients from '../../components/Clients';
import Decisions from '../../common/Decisions';
import ContactsFormBlock from '../../common/ContactsFormBlock';
import Footer from '../../components/Footer';

import tools from './tools';

class Main extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChangeFilter: false,
            isLoadMoreCases: false,
            filters: tools.getFilters(directions),
            casesState: tools.defaultCasesState,
        };

        this.getCases = this.getCases.bind(this);
        this.handleGetMoreCases = this.handleGetMoreCases.bind(this);
        this.handleSwitchFilter = this.handleSwitchFilter.bind(this);
    }

    componentDidMount() {
        this.getCases();
        Analytics.pageView('/', 'Main Page');
    }

    getCases() {
        const { filters, isChangeFilter, casesState: { cases, limit } } = this.state;
        const skip = isChangeFilter ? 0 : cases.length;
        const filterName = tools.getFilterName(filters);
        const filtersID = tools.getServicesIDArray(filters, filterName);
        api.getCases(limit, skip, filtersID)
            .then(({ data }) => this.update(data));
    }

    update(incomingData) {
        const { isChangeFilter, casesState: prevCasesState } = this.state;
        const casesState = tools.updateCasesState(prevCasesState, incomingData, isChangeFilter);

        this.setState({ isChangeFilter: false, isLoadMoreCases: false, casesState });
    }

    handleGetMoreCases() {
        const { casesState } = this.state;
        const moreDownloadNum = tools.getMoreDownloadNum(casesState);
        if (moreDownloadNum > 0) {
            this.setState({ isLoadMoreCases: true });
        }
    }

    handleSwitchFilter(filterName) {
        const { filters: prevFilters } = this.state;
        const filters = tools.updateFilters(prevFilters, filterName);

        this.setState({ filters, isChangeFilter: true });
    }

    render() {
        const {
            isChangeFilter, isLoadMoreCases, filters, casesState,
        } = this.state;
        const {
            className,
            handleOpenPopUp,
            handleChangePage,
            scrollRef,
            isMazeAnimate,
        } = this.props;

        return (
            <Root className={className}>
                <StartScreenMain
                    handleOpenPopUp={handleOpenPopUp}
                    isMazeAnimate={isMazeAnimate}
                />
                <DirectionSection handleChangePage={handleChangePage} />
                <Clients />
                <StyledDecisions
                    decisions={casesState.cases}
                    filters={filters}
                    moreDownloadNum={tools.getMoreDownloadNum(casesState)}
                    onMoreDownloadButtonClick={this.handleGetMoreCases}
                    handleOpenPopUp={handleOpenPopUp}
                    handleSwitchFilter={this.handleSwitchFilter}
                    isChangeFilter={isChangeFilter}
                    isLoadMoreCases={isLoadMoreCases}
                />
                <AnimationContainer
                    withoutMountAndLocationUpdate
                    fade={isChangeFilter || isLoadMoreCases ? 'fadeOut' : 'fadeIn'}
                    callback={isChangeFilter || isLoadMoreCases ? this.getCases : null}
                >
                    <StyledContactsFormBlock scrollRef={scrollRef} />
                </AnimationContainer>
                <Footer handleChangePage={handleChangePage} />
            </Root>
        );
    }
}

const StyledContactsFormBlock = styled(ContactsFormBlock)`
    padding: 64px 0px 64px 0px;

    background: #F5F5F5;

    ${mediaWidth.m} {
        padding: 96px 0px 96px 0px;
    };

    ${mediaWidth.l} {
        padding: 96px 0px 96px 0px;
    }
`;

const StyledDecisions = styled(Decisions)`
    margin: 64px 0px;

    ${mediaWidth.m} {
        margin: 96px 0px;
    };
`;

const Root = styled.div`
    display: flex;
    flex-direction: column;
`;

export default Main;
